import { useState } from 'react';
import AuthCodeForm from './AuthCodeForm';
import EmailForm from './EmailForm';

import styles from './LoginForm.module.css';

function LoginForm() {
  const [email, setEmail] = useState('');
  const [isAuthCodeSended, setIsAuthCodeSended] = useState(false);

  return (
    <div className={styles.container}>
      {isAuthCodeSended ? (
        <AuthCodeForm email={email} />
      ) : (
        <EmailForm email={email} setEmail={setEmail} setIsAuthCodeSended={setIsAuthCodeSended} />
      )}
    </div>
  );
}

export default LoginForm;
